import {computed, inject, Injectable} from '@angular/core';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {lastValueFrom} from 'rxjs';
import {FeatureService} from '../../../../api';
import {FeatureSelect} from '../../../../api/models';
import {QueryKey} from '../../../constants/query-key';

@Injectable({providedIn: 'root'})
export class FeatureStore {
  private readonly featureService = inject(FeatureService);

  private readonly featuresQuery = injectQuery(() => ({
    queryKey: [QueryKey.FEATURE_SELECT],
    queryFn: () => lastValueFrom(this.featureService.getFeatureSelect()),
  }));

  features = computed<FeatureSelect[]>(() => this.featuresQuery.data()?.features ?? []);
  isDataLoading = computed(() => this.featuresQuery.isLoading());
}
